// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZWLy","questions":"styles_questions__vXuUR","footer":"styles_footer__3McPZ"};